import React from 'react';

import { openTrampolineLink } from '../utils/resolveTrampolineLink';

const pillStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '1rem',
    padding: '0.55rem 1.25rem',
    borderRadius: '999px',
    border: '1px solid rgba(255, 255, 255, 0.35)',
    background: 'rgba(255, 255, 255, 0.1)',
    color: '#fff',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.9rem',
    fontWeight: 500,
    cursor: 'pointer',
    textDecoration: 'none',
};

/**
 * Optional CTA under daily goal copy when backend sends actionLink.
 */
export default function DailyGoalActionLink({ actionLink, actionLabel, className, style }) {
    const link = String(actionLink || '').trim();
    if (!link) return null;

    const label = String(actionLabel || '').trim() || 'Open in app';

    return (
        <button
            type="button"
            className={className}
            style={{ ...pillStyle, ...style }}
            onClick={() => openTrampolineLink(link)}
        >
            {label}
        </button>
    );
}
